<template>
	<DropdownWithIcons
		ref="dropdown"
		:options="options"
		:value="value"
		@input="$emit('input', $event)"
	>
		<template #list-footer>
			<li
				class="create-tag-row"
				@click="handleCreate"
			>
				<Icon
					size="lg"
					:inline="true"
					icon-name="e-add"
				/>
				<div class="">
					{{ transUcfirst('tag_group.create') }}
				</div>
			</li>
		</template>
	</dropdownwithicons>
</template>

<script>
import DropdownWithIcons from '@components/dropdown/DropdownWithIcons';
export default {
	name:       'TagGroupsDropdown',
	components: { DropdownWithIcons },
	props:      {
		options: {
			type:    Array,
			default: () => [],
		},
		value: {
			type:    [String, Number, Object],
			default: null,
		},
		disabled: {
			type:    Boolean,
			default: false,
		},
	},
	methods: {
		handleCreate() {
			this.$emit('create-tag-group');
			this.$refs.dropdown.closeDropdown();
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

.create-tag-row {
	padding: 12px;
	color: var(--color-hype-yellow);
	display: flex;
	gap: $sp3-5;
	align-items: center;
	cursor: pointer;
}
</style>
